module.exports = __webpack_public_path__ + "img/admin-feature-postpresscost.cd13eec0.png";